import React from "react";
import { ContentFrame } from "src/styles";
import { StyledForm, InputsContainer, PhotoInput, Container, Content } from "../styles";
import WorkRequestNameInput from "./WorkRequestNameInput";
import { useIsMobile } from "src/hooks/useIsMobile";
import WorkRequestClientLocationInput from "./WorkRequestClientLocationInput";
import WorkRequestServiceTypeSelectSearch from "./WorkRequestServiceTypeSelectSearch";
import WorkRequestSelectClassificationDropdown from "./WorkRequestSelectClassificationDropdown";
import WorkRequestSelectWorkTypeDropdown from "./WorkRequestSelectWorkTypeDropdown";
import { Tooltip as ReactTooltip } from "react-tooltip";
import WorkRequestShowPriorityLevel from "./WorkRequestShowPriorityLevel";
import ServiceTypeQuestion from "../../ServiceTypeQuestion";
import { CustomWorkRequestFieldsForm } from "./CustomWorkRequestFieldsForm";
import WorkRequestDescriptionInput from "./WorkRequestDescriptionInput";
import { IsClientVisbleCheckBoxForm } from "./IsClientVisbleCheckBoxForm";
import WorkRequestResourceInput from "./WorkRequestResourceInput";
import { getAllActiveResources } from "src/redux/selectors/resources";
import { useSelector } from "react-redux";
import { UploadWorkOrderAttachments } from "../../UploadWorkOrderAttachments";
import { EmailToForm } from "./EmailToForm";
import BackButton from "src/components/Button/BackButton";
import { ManagerCreateFormFieldsProps } from "../types";
import WorkRequestTargetDatesInput from "./WorkRequestTargetDatesInput";
import CreateFormButtonContainer from "./CreateFormButtonContainer";

const ManagerCreateFormFields = ({
  formData,
  isVerifyMode,
  setFormData,
  clients,
  clientId,
  locations,
  setClientId,
  serviceTypes,
  workTypes,
  setServiceTypeId,
  serviceTypeId,
  priorityLevels,
  setClassificationId,
  serviceTypeQuestions,
  customWorkRequestFields,
  form,
  setIsResourceAssignedModalVisible,
  assignResourceValues,
  setFiles,
  files,
  onExitClick,
  maximoTimezone,
  targetFinish,
  targetStart,
  timezone,
  buttonDisabledConditions,
  error,
  isLoading,
  onConfirmClick,
  onSubmit,
  setIsVerifyMode,
}: ManagerCreateFormFieldsProps) => {
  const { isMobile } = useIsMobile();
  const activeResources = useSelector(getAllActiveResources);

  return (
    <Container>
      <Content>
        <BackButton backHandler={onExitClick} />
        <ContentFrame>
          <StyledForm>
            <InputsContainer $isMobile={isMobile}>
              <WorkRequestNameInput
                isVerifyMode={isVerifyMode}
                setFormData={setFormData}
                ticketName={formData.ticketName}
              />
              <WorkRequestClientLocationInput
                clients={clients}
                defaultLocation={formData.location}
                isManager={true}
                isVerifyMode={isVerifyMode}
                locations={locations}
                setFormData={setFormData}
                setClientId={setClientId}
                clientId={clientId}
              />
              <WorkRequestServiceTypeSelectSearch
                disabled={false}
                clientId={clientId}
                isManager={true}
                isVerifyMode={isVerifyMode}
                serviceType={formData.serviceType}
                setFormData={setFormData}
                setServiceTypeId={setServiceTypeId}
                workTypes={workTypes}
                serviceTypes={serviceTypes}
              />
              <WorkRequestSelectClassificationDropdown
                classification={formData.classification}
                disabled={!!(isVerifyMode || !serviceTypeId)}
                clientId={clientId}
                isManager={true}
                isNoAuth={false}
                serviceTypeId={serviceTypeId}
                serviceTypes={serviceTypes}
                setClassificationId={setClassificationId}
                setFormData={setFormData}
              />
              <ReactTooltip className="tooltip" />
              <WorkRequestSelectWorkTypeDropdown
                isVerifyMode={isVerifyMode}
                setFormData={setFormData}
                workTypes={workTypes}
              />
              <WorkRequestShowPriorityLevel
                clientId={clientId}
                isVerifyMode={isVerifyMode}
                priorityName={formData.priorityName}
                setFormData={setFormData}
                isNoAuth={false}
                priorityLevels={priorityLevels}
              />
            </InputsContainer>
            {!!serviceTypeQuestions.length &&
              serviceTypeQuestions.map((el) => (
                <ServiceTypeQuestion
                  key={el.id}
                  question={el}
                  formData={formData}
                  setFormData={setFormData}
                  disabled={isVerifyMode}
                />
              ))}
            <WorkRequestDescriptionInput
              description={formData.description}
              isVerifyMode={isVerifyMode}
              setFormData={setFormData}
            />

            {customWorkRequestFields && (
              <CustomWorkRequestFieldsForm
                customWorkRequestFields={customWorkRequestFields[clientId] ?? []}
                $isMobile={isMobile}
                form={form}
                isPublic={false}
                isClient={false}
              />
            )}
            <IsClientVisbleCheckBoxForm form={form} $isMobile={isMobile} />
            <WorkRequestResourceInput
              activeResources={activeResources}
              isVerifyMode={isVerifyMode}
              setIsResourceAssignedModalVisible={setIsResourceAssignedModalVisible}
              assignResourceValues={assignResourceValues}
            />
            {isVerifyMode && files?.length === 0 ? null : (
              <PhotoInput>
                <UploadWorkOrderAttachments setFiles={setFiles} files={files} isViewMode={isVerifyMode} />
              </PhotoInput>
            )}
            <EmailToForm isManager={true} form={form} $isMobile={isMobile} disabled={isVerifyMode} />
            <WorkRequestTargetDatesInput
              isVerifyMode={isVerifyMode}
              maximoTimezone={maximoTimezone}
              targetFinish={targetFinish}
              targetStart={targetStart}
              timezone={timezone}
              showTopLine={files?.length === 0 ? 1 : 0}
            />
            <CreateFormButtonContainer
              error={error}
              buttonDisabledConditions={buttonDisabledConditions}
              isLoading={isLoading}
              isVerifyMode={isVerifyMode}
              onConfirmClick={onConfirmClick}
              onSubmit={onSubmit}
              setIsVerifyMode={setIsVerifyMode}
            />
          </StyledForm>
        </ContentFrame>
      </Content>
    </Container>
  );
};

export default ManagerCreateFormFields;
